export default {
  blik__title: 'Complete your payment with BLIK transfer',
  blik__intro: 'To finish the payment, make a transfer to the phone number below.',
  blik__time_remaining: 'Time remaining',
  blik__amount_label: 'Amount to transfer',
  blik__phone_label: 'Transfer to this phone number',
  blik__full_name_label: 'Recipient first and last name',
  blik__warning:
    'Attention! These payment details are for one-time use and are valid for the displayed time only. Please transfer the exact amount shown on the checkout. Paying after the time limit or reusing these details for another payment will result in an irreversible loss of funds.',
  blik__step_1: 'Copy the payment details displayed on this screen.',
  blik__step_2: 'Open your banking app (or online banking).',
  blik__step_3: 'Find and select the „Przelew na telefon BLIK” (Transfer to phone) option.',
  blik__step_4: 'Enter the phone number:',
  blik__step_5: "Verify that the recipient's first and last name match:",
  blik__step_6: 'The payment amount must exactly match the amount shown on the checkout:',
  blik__step_6_note:
    'If you pay a different amount, you will need to contact the merchant to credit your account.',
  blik__step_7:
    'After making the payment, click the „I have made the transfer” button to check your transaction status.',
  blik__btn_confirm: 'I have made the transfer',
  blik__note_1: 'If you do not complete the transfer, the payment will not be confirmed.',
  blik__note_2: 'If the instruction expires, create a new payment and try again.',
  blik__waiting_title: 'Payment accepted',
  blik__waiting_subtitle:
    'We are waiting for your transfer to arrive. This may take a few minutes.',
  blik__waiting_note: 'The merchant will receive the final payment status once the funds arrive.',
  blik__waiting_btn_return: 'Return to the store',
  blik__confirm_error: 'We could not confirm your payment. Please try again.',
  blik__expired: 'This instruction has expired. Create a new payment and try again.',
};
